import React, { Component } from "react";
import { connect } from "react-redux";
import { getActivities } from "../../reducer";
import { Form } from "semantic-ui-react";
import propTypes from "prop-types";
import { getTranslate } from "react-localize-redux/lib/index";


class ActivitySelect extends Component {

    prepareActivities(){
        if(this.props.activities === null || typeof this.props.activities === 'undefined'){
            return [];
        }
        let activities =  this.props.activities.filter((activity)=>(!this.props.clock || activity.clockable === true)).map((activity)=>(
            {key:activity.id, value:activity.id, text: activity.displayName }
        ));

        if(this.props.empty & this.props.empty === true){
            activities = [];
        }

        if(this.props.additionalActivities !== null && typeof this.props.additionalActivities !== 'undefined'){
            this.props.additionalActivities.forEach((element)=>{
                activities.unshift(element);
            });

        }

        return activities;
    }

    render(){

        return(
                    <Form.Select
                        fluid
                        search
                        selection
                        label={this.props.translate("clock.activities.label")}
                        options={this.prepareActivities()}
                        value={this.props.value}
                        onChange={(e, {value}) => {
                            this.props.onChange(value)
                        }}
                        required
                    />
        )
    }

}

ActivitySelect.propTypes = {
    empty: propTypes.bool,
    onChange: propTypes.func,
    value: propTypes.number,
    clock: propTypes.bool,
    additionalActivities: propTypes.array,
};

const mapStateToProps = state => ({
    activities: getActivities(state),
    translate: getTranslate(state.localize)
});


// No need to connect()!
export default connect(
    mapStateToProps
)(ActivitySelect)



// WEBPACK FOOTER //
// ./src/scenes/Clock/components/ActivitySelect/index.js